import type { ThemeConfig } from 'ant-design-vue/es/config-provider/context'

/**
 * Single source of truth for EReach's visual identity. Every customization goes
 * through this token API — never override AntD's generated class names with
 * :deep()/!important, which breaks silently across version bumps.
 */
export const ereachTheme: ThemeConfig = {
  token: {
    colorPrimary: '#2F4CDD',
    colorInfo: '#2F4CDD',
    colorSuccess: '#16A34A',
    colorWarning: '#D97706',
    colorError: '#DC2626',
    colorTextBase: '#1A1F36',
    colorTextSecondary: '#6B7280',
    colorBgLayout: '#F7F8FA',
    colorBgContainer: '#FFFFFF',
    colorBorderSecondary: '#EDEFF3',
    borderRadius: 8,
    borderRadiusLG: 12,
    fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`,
    fontSize: 14,
    boxShadow: '0 1px 2px rgba(16,24,40,.04), 0 1px 3px rgba(16,24,40,.06)',
    boxShadowSecondary: '0 4px 12px rgba(16,24,40,.08)',
    wireframe: false,
  },
  components: {
    Button: { controlHeight: 40 },
    Input: { controlHeight: 40 },
    Select: { controlHeight: 40 },
    Card: { boxShadowTertiary: '0 1px 2px rgba(16,24,40,.04)' },
    Menu: { radiusItem: 8, colorItemBgSelected: '#EEF1FD', colorItemTextSelected: '#2F4CDD' },
  },
}

/** The same five semantic colors used everywhere status is shown — charts, tags, badges. */
export const semanticPalette = {
  primary: '#2F4CDD',
  success: '#16A34A',
  warning: '#D97706',
  error: '#DC2626',
  neutral: '#6B7280',
} as const
